<script setup lang="ts">
import { ref } from 'vue'
import { useCookies } from "@vueuse/integrations/useCookies";

const calendlyUrl = ref<string>("https://calendly.com/taylor-augmentify/30min?hide_gdpr_banner=1")
const calendlyScriptSrc = "https://assets.calendly.com/assets/external/widget.js"

const calendlyAnswers : { [index : string] : string } = {
  name: 'name',
  email: 'email',
  company: 'a1'
}

const cookies = useCookies()
const user = cookies.get('user')

Object.keys(user).forEach((prop: string) => {
  if(user[prop]) {
    calendlyUrl.value += (`&${calendlyAnswers[prop]}=${user[prop].replaceAll(' ', '%20')}`)
  }
})

const calendlyScript = document.createElement("script")

calendlyScript.setAttribute("src", calendlyScriptSrc)
calendlyScript.setAttribute("async", "true")

document.head.appendChild(calendlyScript)
</script>

<template>
  <div class="calendly-inline-widget" :data-url="calendlyUrl" style="min-width:320px;height:700px;"></div>
</template>